import React, { Component } from "react";
import { consumeApi } from "../js/helpers";
import { Block, Col, Row,Navbar, NavLeft, NavRight, Icon, Link } from "framework7-react";

import { Dom7 } from "framework7";

export default class ReferenciaUnica extends Component {
  constructor(props) {
    super(props);

    this.state = {
      height: "",
      heightFeatures: "",
      uniqueReference: {},
      proveedor: "",
    };
  }
  componentDidMount() {
    const { RU } = this.props;
    if (RU.url.includes("enefevo")) {
      Dom7("#tiendasConekta").addClass("hidden");
      this.setState({ proveedor: "Enefevo" });
    } else if (RU.url.includes("conekta")) {
      Dom7("#tiendasEnefevo").addClass("hidden");
      Dom7("#infoEnefevo").addClass("hidden");
    }

    const height = parseInt(window.innerHeight * 0.6) + "px";
    const heightFeatures = parseInt(window.innerHeight * 0.8) + "px";
    this.setState({ height: height, heightFeatures: heightFeatures });
  }

  render() {
    return (
      <Block>
        {/* <Navbar>
          <NavLeft>
            <div className="Logo"></div>
          </NavLeft>
          <NavRight style={{ paddingRight: "20px" }}>
           
          </NavRight>
        </Navbar> */}
        <Row className="aligner">
          <Col width="100" medium="80" small="95">
            <div id="features" className="divSection rowflex elevation-15">
              <Row className="divTitle">
                <Col width="100" className="">
                  <Col width="85">Referencia Única de Pago</Col>
                </Col>
              </Row>
              <Row>
                <Col className="" width="100">
                  <Row
                    className="aligner"
                    style={{ fontSize: "1.4em", paddingLeft: "20px" }}
                  >
                    <Col width="90" className="">
                      La información de su <strong>referencia única</strong> le
                      ayudará a realizar sus pagos en efectivo.
                    </Col>
                  </Row>
                  <Row className="textCenter">
                    <Col
                      width="100"
                      style={{ paddingTop: "15px", paddingBottom: "15px" }}
                    >
                      <Col width="50" className="Aligner">
                        <img
                          src={"data:image/png;base64," + this.props.RU.image}
                          width={"200 px"}
                        ></img>
                      </Col>
                    </Col>
                  </Row>
                  <Row className="aligner" style={{ fontSize: "1.2em" }}>
                    <Col width="90" className="aligner">
                      <strong>{this.props.RU.reference}</strong>
                    </Col>
                  </Row>
                  <Row
                    className="aligner"
                    style={{ fontSize: "18px", paddingLeft: "20px" }}
                  >
                    <Col width="90" className="">
                      <p>
                        Paga con tu referencia única{" "}
                        <strong>{this.props.RU.provider}</strong> en cualquiera
                        de las siguientes cadenas:
                      </p>
                    </Col>
                  </Row>
                  <div id="tiendasEnefevo">
                    <Row>
                      <Col width="100">
                        <Row>
                          <Col
                            width="10"
                            medium="5"
                            small="15"
                            xsmall="15"
                            className="checkMarkRU"
                          >
                            <Icon f7="checkmark_alt_circle_fill"></Icon>
                          </Col>
                          <Col width="90" medium="95" small="85" xsmall="85">
                            7-Eleven
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col width="100">
                        <Row>
                          <Col
                            width="10"
                            medium="5"
                            small="15"
                            xsmall="15"
                            className="checkMarkRU"
                          >
                            <Icon f7="checkmark_alt_circle_fill"></Icon>
                          </Col>
                          <Col width="90" medium="95" small="85" xsmall="85">
                            Circle K, Extra y K
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col width="100">
                        <Row>
                          <Col
                            width="10"
                            medium="5"
                            small="15"
                            xsmall="15"
                            className="checkMarkRU"
                          >
                            <Icon f7="checkmark_alt_circle_fill"></Icon>
                          </Col>
                          <Col width="90" medium="95" small="85" xsmall="85">
                            Soriana
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col width="100">
                        <Row>
                          <Col
                            width="10"
                            medium="5"
                            small="15"
                            xsmall="15"
                            className="checkMarkRU"
                          >
                            <Icon f7="checkmark_alt_circle_fill"></Icon>
                          </Col>
                          <Col width="90" medium="95" small="85" xsmall="85">
                            Farmacias del Ahorro
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col width="100">
                        <Row>
                          <Col
                            width="10"
                            medium="5"
                            small="15"
                            xsmall="15"
                            className="checkMarkRU"
                          >
                            <Icon f7="checkmark_alt_circle_fill"></Icon>
                          </Col>
                          <Col width="90" medium="95" small="85" xsmall="85">
                            Waldos
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col width="100">
                        <Row>
                          <Col
                            width="10"
                            medium="5"
                            small="15"
                            xsmall="15"
                            className="checkMarkRU"
                          >
                            <Icon f7="checkmark_alt_circle_fill"></Icon>
                          </Col>
                          <Col width="90" medium="95" small="85" xsmall="85">
                            Super Kiosko
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col width="100">
                        <Row>
                          <Col
                            width="10"
                            medium="5"
                            small="15"
                            xsmall="15"
                            className="checkMarkRU"
                          >
                            <Icon f7="checkmark_alt_circle_fill"></Icon>
                          </Col>
                          <Col width="90" medium="95" small="85" xsmall="85">
                            Farmacias Bazar
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col width="100">
                        <Row>
                          <Col
                            width="10"
                            medium="5"
                            small="15"
                            xsmall="15"
                            className="checkMarkRU"
                          >
                            <Icon f7="checkmark_alt_circle_fill"></Icon>
                          </Col>
                          <Col width="90" medium="95" small="85" xsmall="85">
                            Farmacias Unión
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col width="100">
                        <Row>
                          <Col
                            width="10"
                            medium="5"
                            small="15"
                            xsmall="15"
                            className="checkMarkRU"
                          >
                            <Icon f7="checkmark_alt_circle_fill"></Icon>
                          </Col>
                          <Col width="90" medium="95" small="85" xsmall="85">
                            Consulta todos los puntos de venta afiliados para
                            realizar tu pago
                            <Link
                              href="https://www.enefevo.com.mx/"
                              external
                              target="_blank"
                            >
                              &nbsp;aquí
                            </Link>
                          </Col>
                        </Row>
                      </Col>
                    </Row> */}
                  </div>
                  <div id="tiendasConekta">
                    <Row>
                      <Col width="100">
                        <Row>
                          <Col
                            width="10"
                            medium="5"
                            small="15"
                            xsmall="15"
                            className="checkMarkRU"
                          >
                            <Icon f7="checkmark_alt_circle_fill"></Icon>
                          </Col>
                          <Col width="90" medium="95" small="85" xsmall="85">
                            OXXO
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                  <Row
                    className="aligner"
                    style={{ fontSize: "18px", paddingLeft: "20px" }}
                  >
                    <Col width="90" className="">
                      <p>
                        En estos establecimientos tus pagos se verán reflejados
                        de <strong>inmediato</strong>.
                      </p>
                    </Col>
                  </Row>
                  <Row
                    width=""
                    style={{ fontSize: "18px", paddingLeft: "20px" }}
                  >
                    <Col width="90" className="">
                      <p>Sigue los siguientes pasos:</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col width="100">
                      <Row>
                        <Col
                          width="10"
                          medium="5"
                          small="15"
                          xsmall="15"
                          className="checkMarkRU"
                        >
                          <Icon f7="checkmark_alt_circle_fill"></Icon>
                        </Col>
                        <Col width="90" medium="95" small="85" xsmall="85">
                          Visita uno de estos establecimientos
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col width="100">
                      <Row>
                        <Col
                          width="10"
                          medium="5"
                          small="15"
                          xsmall="15"
                          className="checkMarkRU"
                        >
                          <Icon f7="checkmark_alt_circle_fill"></Icon>
                        </Col>
                        <Col width="90" medium="95" small="85" xsmall="85">
                          Indica al Cajero que quieres realizar un Pago de
                          Servicio <strong>{this.state.proveedor}</strong>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row style={{ paddingBottom: "20px" }}>
                    <Col width="100">
                      <Row>
                        <Col
                          width="10"
                          medium="5"
                          small="15"
                          xsmall="15"
                          className="checkMarkRU"
                        >
                          <Icon f7="checkmark_alt_circle_fill"></Icon>
                        </Col>
                        <Col width="90" medium="95" small="85" xsmall="85">
                          Presenta al cajero el código de barras o el número de
                          tu referencia única
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  {/* <Row style={{ paddingBottom: "20px" }}>
                    <Col width="100" id="infoEnefevo">
                      <Row>
                        <Col
                          width="10"
                          medium="5"
                          small="15"
                          xsmall="15"
                          className="checkMarkRU"
                        >
                          <Icon f7="checkmark_alt_circle_fill"></Icon>
                        </Col>
                        <Col width="90" medium="95" small="85" xsmall="85">
                          <Link
                            href="http://lm0.eu/fZNpjxP"
                            external
                            target="_blank"
                          >
                            más información
                          </Link>
                        </Col>
                      </Row>
                    </Col>
                  </Row> */}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Block>
    );
  }
}
